import { afTheme } from '@/config/vuetify/theme';
import type { App } from 'vue';

export default {
  install: (app: App) => {
    function color(key: string): string {
      const { colors } = afTheme;
      if (!colors[key]) {
        console.warn(`Color ${key} doesn't exist in theme.`);
        return 'red';
      }
      const value = colors[key];
      return typeof value === 'string' ? value : String(value);
    }

    app.config.globalProperties.$theme = color;
    app.provide('theme', color);
  },
};
